<template>
  <div>
    <TeamInfo v-bind:game="matchInfo" :goal="matchGoalInfo" :highlight="matchHighlightInfo" @highlight="currentTab = 2"/>
    <!-- <TeamInfo :game="matchInfo" :goal="matchGoalInfo" :highlight="matchHighlightInfo" @highlight="currentTab = 2"/> -->

    <div class="tab-box-line">
      <ul class="tab-btn-list">
        <li v-for="(tab, index) in tabList" :key="index" :class="{active:currentTab === index}"
            @click="tabIndexChange(currentTab)">
          <a href="#" @click.prevent="currentTab = index">{{ tab.title }}</a>
        </li>
      </ul>
    </div>

    <div v-if="currentTab === 0" >
      <MatchRecord :game="matchInfo" />
      <div class="division-line"></div>
      <MatchChart :game="matchInfo" />
      <div class="division-line"></div>
      <MatchTimeLines :game="matchInfo" :timeline="timelineInfo" :isReady="timelineIsReady"/>
      <!-- <MatchTimeLines :game="matchInfo" :timeline="timelineInfo" :isReady="timelineIsReady"/> -->
    </div>

    <div v-if="currentTab === 1">
      <MatchPlayerRecord />
    </div>
    <div v-if="currentTab === 2">
      <MatchHighlight :highlight="matchHighlightInfo"/>
    </div>

  </div>
</template>

<script>
import {leagueName, oldLeagueName} from "@/lib/match";
import TeamInfo from '@/components/Match/TeamInfo.vue';
import MatchRecord from '@/components/Match/MatchRecord.vue';
import MatchChart from '@/components/Match/MatchChart.vue';
import MatchTimeLines from '@/components/Match/MatchTimeLine.vue';
import MatchPlayerRecord from '@/components/Match/MatchPlayerRecord.vue';
import MatchHighlight from '@/components/Match/MatchHighlight.vue';
import {isEmpty} from '@/lib';

export default {
  name : 'MatchDetail',
  components: {
    TeamInfo,
    MatchHighlight,
    MatchRecord,
    MatchChart,
    MatchTimeLines,
    MatchPlayerRecord
  },
  data() {
    return {
      componentKey: 0,
      tabList: [
        {
          title: '경기기록',
          type: 'match'
        }, {
          title: '선수별 기록',
          type: 'player'
        }, {
          title: '하이라이트',
          type: 'highlight'
        }
      ],
      currentTab: 0,
      gameId: '',
      meetSeq: '',
      meetYear: '',
      matchInfo: {},
      matchGoalInfo: [],
      matchRecordInfo: {},
      matchPlayerInfo: {},
      matchHighlightInfo: {},
      timelineInfo: [],
      timelineIsReady: false
    }
  },
  computed: {
    paramsId () {
      return this.$route.params.id;
    },
  },
  async created() {
    const query = this.$route.query;

    if (query.tab) {
      this.currentTab = Number(query.tab);
    }

    const detailId = this.$route.params.id.split('_');
    this.meetYear = detailId[0];
    this.meetSeq = detailId[1];
    this.gameId = detailId[2];

    await this.getInfo()
    await this.getTimelineInfo()
    await this.getHighlightInfo()
  },
  methods: {
    tabIndexChange(val) {
      if(val === 0) {
        this.getInfo()
        this.getTimelineInfo()
      }
    },
    getInfo() {
      this.getGoalInfo();
      if(this.meetYear < 2013) {
        this.getOldMatchInfo();
      } else {
        this.getMatchInfo();
      }
    },
    async getGoalInfo() {
      ///game/timeline?year=2023&seq=2&game_id=232&type=goal
      const {data} = await this.$http.get(`/game/timeline?year=${this.meetYear}&seq=${this.meetSeq}&game_id=${this.gameId}&type=goal`);
      if(data.success) {
        this.matchGoalInfo = data.data;
      }
    },
    async getMatchInfo() {
      const {data} = await this.$http.get(`/game/detail?year=${this.meetYear}&seq=${this.meetSeq}&game_id=${this.gameId}`);
      if(data.success) {
        this.setInfo(data.data, 'new');
      } /*else {
        alert('데이터가 없습니다.');
        return this.$router.push({name: 'matchList'});
      }*/
    },
    async getOldMatchInfo() {
      const {data} = await this.$http.get(`/past_game/detail?year=${this.meetYear}&seq=${this.meetSeq}&game_id=${this.gameId}`);
      if(data.success) {
        this.setInfo(data.data, 'old');
      } /*else {
        alert('데이터가 없습니다.');
        return this.$router.push({name: 'matchList'});
      }*/
    },
    async getHighlightInfo() {
      const {data} = await this.$http.get(`/game/highlight?year=${this.meetYear}&game_id=${this.gameId}&type=highlight`);
      if(data.success) {
        this.matchHighlightInfo = data.data;
      }
    },
    setInfo(data, type) {
      if(type === 'old') {
        data.league_name = oldLeagueName(data.meet_seq, data.meet_name);
      } else {
        data.league_name = leagueName(data.meet_name);
      }

      if(data.league_name === 'facup') {
        data.league_name_prt = 'FA CUP';
      } else {
        data.league_name_prt = 'K LEAGUE';
      }

      if(data.home_team === 'K07') {
        data.type = '홈';
      } else {
        data.type = '어웨이';
      }
      this.matchInfo = data;
    },
    async getTimelineInfo() {
      const {data} = await this.$http.get(`/game/timeline?year=${this.meetYear}&seq=${this.meetSeq}&game_id=${this.gameId}`);
      if(data.success) {
        if(data.data.length > 0) {
          this.timelineIsReady = true;
        }
        this.timelineInfo = data.data;
      }
    }
  }
}
</script>
